export default "__VITE_ASSET__B6W4mvvk__"